module.exports = __webpack_public_path__ + "static/media/login_top_left.38547180.svg";